/* eslint-disable complexity */
import React, { useState, useContext, ReactNode } from 'react';

import { SidePanelContext, SidePanelContextProps } from '../context/side-panel';
import { AssistantSidePanel, ASSISTANT_TAB } from '../../../ui/assistant-side-panel/assistant-side-panel';
import { UserGridSettingsContext } from '../reports/user-grid-settings/user-grid-settings-context';

export const SidePanelContextProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [initialActiveTab, setInitialActiveTab] = useState(ASSISTANT_TAB.PREDICTIONS);

  const {
    bulkUpdatesInvoicesBills: {
      handleChangeIsCustomSelect,
      handleChangeShowCheckboxes,
      handleChangeSelectedInvoicesBills
    }
  } = useContext(UserGridSettingsContext);

  const openSidePanel = (newSidePanelProps?: SidePanelContextProps, activeTab?: ASSISTANT_TAB) => {
    if (!newSidePanelProps) {
      if (activeTab) {
        setInitialActiveTab(activeTab);
      }
      onOpenSidePanel();
      return;
    }
  };

  const onOpenSidePanel = () => {
    setIsOpen(true);
  };

  const closeSidePanel = () => {
    setIsOpen(false);
    handleChangeShowCheckboxes(false);
    handleChangeSelectedInvoicesBills([]);
    handleChangeIsCustomSelect(true);
    setInitialActiveTab(ASSISTANT_TAB.PREDICTIONS);
  };

  return (
    <SidePanelContext.Provider
      value={{
        openSidePanel,
        closeSidePanel
      }}
    >
      {children}
      <AssistantSidePanel
        isOpen={isOpen}
        onOpen={onOpenSidePanel}
        onClose={closeSidePanel}
        initialActiveTab={initialActiveTab}
      />
    </SidePanelContext.Provider>
  );
};
